import { render, staticRenderFns } from "./Zhuanyun.vue?vue&type=template&id=237e6654&scoped=true&"
import script from "./Zhuanyun.vue?vue&type=script&lang=js&"
export * from "./Zhuanyun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e6654",
  null
  
)

export default component.exports